import React, { useEffect, useState, useRef } from "react";
import { Modal, Button, Table, Pagination } from "react-bootstrap";
import { getvideos, update_cutouts, make_video_live } from './api';
import Hls from "hls.js";

const pageSize = 30;

export default function SessionRecordings() {
  const [videos, setVideos] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedVideo, setSelectedVideo] = useState<any | null>(null);
  const [cutStart, setCutStart] = useState<number | null>(null);
  const [cutMode, setCutMode] = useState(false);
  // const [videoRef, setVideoRef] = useState<HTMLVideoElement | null>(null);
  const [editingCutoutIndex, setEditingCutoutIndex] = useState<number | null>(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  let itv1 = null;
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    getvideos().then(setVideos);
    itv1 = setInterval(() => {
      getvideos().then(setVideos);
    }, 10000)
    return () => clearInterval(itv1);
  }, []);

  // useEffect(() => {
  //   if (!!selectedVideo?.url_m3u8 && Hls.isSupported()) {
  //     const hls = new Hls();
  //     hls.loadSource(selectedVideo?.url_m3u8);
  //     hls.attachMedia(videoRef.current);
  //   }
  // }, [selectedVideo]);

  const totalPages = Math.ceil(videos.length / pageSize);
  const currentVideos = videos.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const handleVideoClick = () => {
    if (!cutMode || !videoRef || !selectedVideo) return;

    if (cutStart === null) {
      setCutStart(Math.round(videoRef.current.currentTime));
    } else {
      const newCut = {
        fromsec: Math.round(Math.min(cutStart, videoRef.current.currentTime)),
        tosec: Math.round(Math.max(cutStart, videoRef.current.currentTime))
      };

      const updatedVideo = { ...selectedVideo };
      if (editingCutoutIndex !== null) {
        updatedVideo.cutouts[editingCutoutIndex] = newCut;
      } else {
        updatedVideo.cutouts = [...(updatedVideo.cutouts || []), newCut];
      }

      setSelectedVideo(updatedVideo);
      setCutStart(null);
      setEditingCutoutIndex(null);
      setCutMode(false);
      setHasUnsavedChanges(true);
    }
  };

  const handleSelectCurrentTime = () => {
    if (!videoRef || !selectedVideo) return;

    if (cutStart === null) {
      setCutStart(Math.round(videoRef.current.currentTime));
    } else {
      const newCut = {
        fromsec: Math.round(Math.min(cutStart, videoRef.current.currentTime)),
        tosec: Math.round(Math.max(cutStart, videoRef.current.currentTime))
      };

      const updatedVideo = { ...selectedVideo };
      if (editingCutoutIndex !== null) {
        updatedVideo.cutouts[editingCutoutIndex] = newCut;
      } else {
        updatedVideo.cutouts = [...(updatedVideo.cutouts || []), newCut];
      }

      setSelectedVideo(updatedVideo);
      setCutStart(null);
      setEditingCutoutIndex(null);
      setCutMode(false);
      setHasUnsavedChanges(true);
    }
  };

  const handleRemoveCutout = (index: number) => {
    if (!selectedVideo) return;

    const updatedVideo = { ...selectedVideo };
    updatedVideo.cutouts = updatedVideo.cutouts.filter((_: any, i: number) => i !== index);
    setSelectedVideo(updatedVideo);
    setHasUnsavedChanges(true);
  };

  const handleEditCutout = (index: number) => {
    if (!videoRef?.current || !selectedVideo) return;
    setEditingCutoutIndex(index);
    setCutMode(true);
    setCutStart(null); // Reset to allow selecting new start time
    videoRef.current.currentTime = selectedVideo.cutouts[index].fromsec;
  };

  const handleSaveChanges = () => {
    if (!selectedVideo) return;

    update_cutouts({
      discussionid: selectedVideo.discussionid,
      cutouts: selectedVideo.cutouts
    }).then(() => {
      setHasUnsavedChanges(false);
      // Refresh the video list
      getvideos().then(setVideos);
      // Close the modal
      // setSelectedVideo(null);
      videoRef.current = null;
    });
  };

  const openModal = (video: any) => {
    if (hasUnsavedChanges) {
      if (window.confirm('All changes will be lost. Are you sure?')) {
        setSelectedVideo({ ...video, cutouts: video.cutouts ? [...video.cutouts] : [] });
        setCutStart(null);
        setCutMode(false);
        setEditingCutoutIndex(null);
        setHasUnsavedChanges(false);
      }
    }
    else {
      setSelectedVideo({ ...video, cutouts: video.cutouts ? [...video.cutouts] : [] });
      setCutStart(null);
      setCutMode(false);
      setEditingCutoutIndex(null);

      setTimeout(() => {
        const hls = new Hls();
        hls.loadSource(video?.url_m3u8);
        hls.attachMedia(videoRef.current);
      }, 700)
    }
  };

  const makeLive = (video: any) => {
    console.log(video);
    if (!video.cutouts?.length) {
      alert("Please add cutouts to the video before making it live.");
    }
    else if (['Transcoding', 'GeneratingMP3', 'UploadingTrimmedMP4', 'GeneratingStoryboard', 'Trimming', 'Downloading', 'GeneratingSubtitles', 'UploadingSubtitles'].includes(video.recforge_status)) {
      alert("This video is still being processed. Please wait a few minutes and try again.");
    }
    else {
      if (video.rc_url?.length > 0) {
        if (window.confirm("This will update the existing replay URL, are you sure?")) {
          const resp = make_video_live({ discussionid: video.discussionid });
          if (!resp) alert("Some problem occurred. Please try again");
        }
      } else {
        const resp = make_video_live({ discussionid: video.discussionid });
        if (!resp) alert("Some problem occurred. Please try again");
      }
    }
  }

  const toggleCutMode = () => {
    if (cutMode) {
      // Cancel cut mode
      setCutMode(false);
      setCutStart(null);
      setEditingCutoutIndex(null);
    } else {
      // Enter cut mode
      setCutMode(true);
      setCutStart(null);
      setEditingCutoutIndex(null);
    }
  };

  const renderTimeline = () => {
    if (!selectedVideo || !videoRef?.current?.duration) return null;

    const duration = videoRef.current.duration;
    const cutouts = selectedVideo.cutouts || [];

    return (
      <div style={{
        width: '100%',
        height: '20px',
        background: '#eee',
        position: 'relative',
        marginTop: '10px',
        borderRadius: '4px'
      }}>
        {cutouts.map((cut: any, index: number) => (
          <div
            key={index}
            style={{
              position: 'absolute',
              left: `${(cut.fromsec / duration) * 100}%`,
              width: `${((cut.tosec - cut.fromsec) / duration) * 100}%`,
              height: '100%',
              background: 'rgba(83, 1, 0, 0.5)',
              cursor: 'pointer',
              borderRadius: '2px'
            }}
            onClick={() => handleEditCutout(index)}
          />
        ))}
        {cutStart !== null && (
          <div
            style={{
              position: 'absolute',
              left: `${(cutStart / duration) * 100}%`,
              width: '2px',
              height: '100%',
              background: 'blue'
            }}
          />
        )}
      </div>
    );
  };

  const renderCutouts = () => {
    if (!selectedVideo) return null;
    return (selectedVideo.cutouts || []).map((cut: any, index: number) => (
      <div
        key={index}
        style={{
          background: "#530100",
          padding: "4px",
          margin: "4px",
          cursor: "pointer",
          color: "white",
          borderRadius: '4px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}
      >
        <span onClick={() => handleEditCutout(index)}>
          Cutout: {Math.round(cut.fromsec)}s - {Math.round(cut.tosec)}s
        </span>
        {cutMode && (
          <Button
            variant="danger"
            size="sm"
            style={{ backgroundColor: "#530100", borderColor: "#530100" }}
            onClick={(e) => {
              e.stopPropagation();
              handleRemoveCutout(index);
            }}
          >
            Remove
          </Button>
        )}
      </div>
    ));
  };

  return (
    <div style={{ padding: "20px" }}>
      <h3>Recordings</h3>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Discussion ID</th>
            <th>Title</th>
            <th>Date</th>
            <th>Status</th>
            <th>Recording</th>
            <th>Process</th>
            <th>Transcript</th>
          </tr>
        </thead>
        <tbody>
          {currentVideos.map(video => (
            <tr key={video.discussionid}>
              <td>{video.discussionid}</td>
              <td>{video.title}</td>
              <td>{video.startdate}</td>
              <td>{video.recforge_status}</td>
              <td>
                <Button onClick={() => openModal({ ...video, cutouts: [...(video.cutouts ?? [])] })}>
                  View / Edit
                </Button>
              </td>
              <td>
                <Button onClick={() => makeLive(video)}>
                  Make Live
                </Button>
              </td>
              <td>
                {['Live'].includes(video.recforge_status) ? (
                  <div style={{flexDirection:'row'}}>
                    <Button target="blank" variant="link" href={video.srt_url} style={{fontSize: 12}}>Open</Button>
                  </div>
                ) : <></>}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Pagination>
        {Array.from({ length: totalPages }).map((_, i) => (
          <Pagination.Item key={i} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>
            {i + 1}
          </Pagination.Item>
        ))}
      </Pagination>

      <Modal
        show={!!selectedVideo}
        onHide={() => {
          if (cutMode) {
            return; // Prevent closing when in cutout mode
          }
          if (hasUnsavedChanges) {
            if (window.confirm('All changes will be lost. Are you sure?')) {
              setSelectedVideo(null);
              setHasUnsavedChanges(false);
              videoRef.current = null;
            }
          } else {
            setSelectedVideo(null);
            videoRef.current = null;
          }
        }}
        backdrop={cutMode ? "static" : true}
        keyboard={!cutMode}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{selectedVideo?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ marginBottom: "10px", display: "flex", gap: "10px", alignItems: "center" }}>
            <Button
              variant={cutMode ? "danger" : "secondary"}
              onClick={toggleCutMode}
              style={cutMode ? { backgroundColor: "#530100", borderColor: "#530100" } : undefined}
            >
              {cutMode ? "Cancel Cut" : "Add Cutout"}
            </Button>
            {hasUnsavedChanges && (
              <Button
                variant="primary"
                onClick={handleSaveChanges}
              >
                Save All Changes
              </Button>
            )}
          </div>
          {cutMode && (
            <div style={{ marginTop: "10px", display: "flex", alignItems: "center", gap: "10px" }}>
              <span style={{ color: "#530100" }}>
                {cutStart === null ? "Select start time" : "Select end time"}
              </span>
              <Button
                variant="primary"
                size="sm"
                onClick={handleSelectCurrentTime}
              >
                Mark Time
              </Button>
            </div>
          )}
          {/* <video
            width="100%"
            height="auto"
            controls
            src={selectedVideo?.url_mp4}
            ref={(ref) => ref && setVideoRef(ref)}
            onClick={handleVideoClick}
            style={{ border: "1px solid #ccc" }}
          /> */}
          <video
            ref={videoRef}
            controls
            width="100%"
            height="auto"
            style={{ border: '1px solid #ccc' }}
          />
          {renderTimeline()}
          <div style={{ marginTop: "10px" }}>
            <strong>Cutouts:</strong>
            <div style={{ display: "flex", flexWrap: "wrap" }}>{renderCutouts()}</div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
